import {
  Link,
  Outlet,
  createFileRoute,
  redirect,
} from "@tanstack/react-router";

import { Brand } from "../components/Brand";
import { useSession } from "../lib/auth";
import { supabase } from "../lib/supabase";

export const Route = createFileRoute("/_auth")({
  beforeLoad: async ({ context, location }) => {
    const { data } = await context.supabase.auth.getSession();
    if (!data.session) {
      throw redirect({
        to: "/login",
        search: { redirect: location.href },
      });
    }
  },
  component: AuthLayout,
});

function AuthLayout() {
  return (
    <>
      <Header />
      <Outlet />
    </>
  );
}

function Header() {
  const { data: session } = useSession();
  const email = session?.user.email ?? "";
  const role = session?.user.app_metadata?.role as string | undefined;

  async function handleSignOut() {
    await supabase.auth.signOut();
  }

  return (
    <header className="app-header">
      <Brand />
      <nav className="app-nav">
        <Link to="/projects" activeProps={{ className: "active" }}>
          Projects
        </Link>
        <Link to="/payment-orders" activeProps={{ className: "active" }}>
          Payment orders
        </Link>
        <Link to="/review" activeProps={{ className: "active" }}>
          Review queue
        </Link>
        <Link to="/bootstrap" activeProps={{ className: "active" }}>
          Bootstrap
        </Link>
        {role === "project_owner" ? (
          <>
            <Link to="/crm-profiles" activeProps={{ className: "active" }}>
              CRM profiles
            </Link>
            <Link to="/admin" activeProps={{ className: "active" }}>
              Admin
            </Link>
          </>
        ) : null}
      </nav>
      <div className="app-user">
        {email ? <span>{email}</span> : null}
        <button type="button" className="btn btn--ghost" onClick={handleSignOut}>
          Sign out
        </button>
      </div>
    </header>
  );
}
